import * as React from 'react'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useLeadCompanyRequiredFields } from './LeadCompanyRequiredFieldsContext'

const styles = {
  alert: {
    border: 'solid 1px #f0c988',
    alignItems: 'center',
    py: 0,
    '& .MuiAlert-message': { p: 0 },
    '& .MuiAlert-icon': { fontSize: 15, mr: '6px' },
  },
  cardAlert: {
    borderBottom: '0',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    width: 'fit-content',
  },
  link: { fontWeight: '500', width: 'max-content', color: '#005aa3' },
}

interface Props {
  variant?: 'card' | 'detail'
}

/** Warning shown on card and detail views of an auto-reviewed lead missing company-required fields. */
export function LeadCompanyRequiredFieldsBanner(props: Props) {
  const { variant = 'detail' } = props
  const { hasMissing, openUpdate } = useLeadCompanyRequiredFields()

  if (!hasMissing) return null

  const isCard = variant === 'card'

  const alert = (
    <Alert
      severity="warning"
      sx={isCard ? [styles.alert, styles.cardAlert] : styles.alert}
      data-test-id="lead-company-required-fields-banner"
    >
      <Typography variant="body2">
        This lead was auto-reviewed and is missing required information. The
        lead cannot be converted to an opportunity or closed/won until all
        required information is provided.
        <Button
          size="small"
          color="inherit"
          onClick={openUpdate}
          data-test-id="lead-company-required-fields-banner-update"
          sx={styles.link}
        >
          Update Required Fields
        </Button>
      </Typography>
    </Alert>
  )

  return isCard ? (
    <Box pl="16px">{alert}</Box>
  ) : (
    <Stack
      alignItems="start"
      marginX="auto"
      maxWidth={1368}
      mt="20px"
      paddingX="20px"
    >
      <Stack maxWidth={1368} mt="10px">
        {alert}
      </Stack>
    </Stack>
  )
}

LeadCompanyRequiredFieldsBanner.displayName = 'LeadCompanyRequiredFieldsBanner'
